export default {
    common: {
        saved: 'Zapisane.',
        savedWeight: 'Zapisane: {weight}.',
        saveFailed: 'Nie udało się zapisać. Spróbuj ponownie.',
        deleteFailed: 'Nie udało się usunąć.',
        saving: 'Zapisuję…',
        save: 'Zapisz',
        add: 'Dodaj',
        remove: 'Usuń',
        days: '{n} dni',
        weekDays: 'Dni tygodnia',
        chartRange: 'Zakres wykresu',
        showOlder: 'Pokaż starsze',
        workout: 'Trening',
        measurement: 'Pomiar',
        weighIn: 'Zważ się',
        workoutUnit: 'trening | treningi | treningów',
        markDoneAria: '{name}: oznacz jako zrobiony',
        doneTitle: 'Zrobione',
        doneFlash: '{name} — zrobione!',
        markFailed: 'Nie udało się odhaczyć treningu.',
        perWeek: '{weight} / tydzień',
    },
    quality: {
        l1: 'Fatalnie',
        l2: 'Słabo',
        l3: 'Tak sobie',
        l4: 'Dobrze',
        l5: 'Świetnie',
    },
    suggestions: {
        running: 'Bieganie',
        gym: 'Siłownia',
        cycling: 'Rower',
        walking: 'Spacer',
        yoga: 'Joga',
        swimming: 'Pływanie',
    },
    now: {
        title: 'Teraz',
        highlightNight: {
            title: 'Pierwsza noc',
            text: 'Wieczorem tapnij „Kładę się", a rano przycisk pobudki. Zapomnianą noc dopiszesz na zakładce Sen.',
        },
        highlightQuality: {
            title: 'Oceń noc',
            text: 'Po pobudce w tej karcie pojawi się ocena — jedno tapnięcie. Starszą noc ocenisz na zakładce Sen.',
        },
        wakeMale: 'Wstałem',
        wakeFemale: 'Wstałam',
        wakeNeutral: 'Pobudka',
        versusSame: 'tyle co średnio z 7 dni',
        versusDiff: '{diff} względem średniej z 7 dni',
        bedFlash: 'Dobranoc. Zaśnięcie: {time}.',
        wakeFlash: 'Dzień dobry! Jak się spało?',
        ratedFlash: 'Zapisane: {quality}.',
        nightOngoing: 'NOC TRWA',
        tonight: 'DZISIEJSZA NOC',
        lastNight: 'OSTATNIA NOC',
        sleep: 'SEN',
        sleepLink: 'Sen',
        sinceBedtime: 'od zaśnięcia o {time}',
        wokeAt: 'pobudka {time}',
        addBedtime: 'dopisz zaśnięcie',
        howSleptQuestion: 'Jak się spało?',
        howSlept: 'Jak się spało',
        qualityLine: 'Jakość: {quality}',
        noNightsTitle: 'Jeszcze żadnej nocy',
        noNightsText: 'Wieczorem tapnij „Kładę się", a rano przycisk pobudki — resztę policzymy sami.',
        goToBed: 'Kładę się',
        fixTime: 'Popraw godzinę',
        addNight: 'Dopisz noc ręcznie',
        activityTitle: 'RUCH · TEN TYDZIEŃ',
        activityLink: 'Ruch',
        weekTotal: 'razem {duration}',
        weekEmpty: 'jeszcze nic w tym tygodniu',
        dotDone: 'trening zrobiony',
        dotPlanned: 'trening zaplanowany',
        dotNone: 'bez treningu',
        weightTitle: 'WAGA',
        weightLink: 'Waga',
        today: 'dziś',
        toTarget: 'Do celu {weight}',
        reached: 'osiągnięty',
        sparkAria: 'Trend wagi z 30 dni',
        weighEmpty: 'Zważ się — od pierwszego pomiaru zacznie się wykres i trend. Najlepiej rano, o podobnej porze.',
    },
    sleep: {
        title: 'Sen',
        action: 'Noc',
        subtitle: 'średnio {duration} z {days} dni',
        lengthTitle: 'DŁUGOŚĆ NOCY',
        regularityTitle: 'REGULARNOŚĆ · {days} DNI',
        fallAsleep: 'Zasypiasz średnio',
        wakeUp: 'Wstajesz średnio',
        regularityEmpty: 'Policzymy, gdy będą pełne noce (z zaśnięciem i pobudką) z ostatnich {days} dni.',
        nightsTitle: 'NOCE',
        noWake: 'bez pobudki',
        noBedtime: 'bez zaśnięcia',
        nap: 'drzemka {range} · {length}',
        qualityAria: 'Jakość: {quality}',
        empty: 'Jeszcze żadnej nocy. Na ekranie {now} zapiszesz ją jednym tapnięciem.',
        emptyLink: 'Teraz',
    },
    activity: {
        title: 'Ruch',
        subtitle: '{n} trening w 30 dni | {n} treningi w 30 dni | {n} treningów w 30 dni',
        thisWeek: 'Ten tydzień',
        lastWeek: 'Poprzedni tydzień',
        thisWeekTitle: 'TEN TYDZIEŃ',
        dayDone: '{n} zrobione',
        dayPlanned: 'zaplanowany',
        dayNone: 'bez treningu',
        minutes: 'min',
        addTitle: 'DODAJ',
        plan: 'Zaplanuj',
        types: 'Rodzaje treningów ({n})',
        plannedTitle: 'ZAPLANOWANE',
        notTickedTitle: 'Nie odhaczony — zrobione?',
        notTicked: 'nie odhaczony',
        empty: 'Jeszcze żadnego treningu. Dodaj pierwszy albo zaplanuj go na jutro.',
        statsTitle: 'OSTATNIE 30 DNI',
        distanceTotal: '{distance} razem',
        statsEmpty: 'Pojawi się po pierwszym zrobionym treningu.',
    },
    weight: {
        title: 'Waga',
        year: 'Rok',
        all: 'Całość',
        etaWeek: 'w tym tempie — za tydzień',
        etaLong: 'w tym tempie — za ponad 2 lata',
        etaDate: 'w tym tempie — około {date}',
        deletedFlash: 'Pomiar usunięty.',
        targetRemovedFlash: 'Waga docelowa usunięta.',
        targetFlash: 'Cel: {weight}.',
        trendTitle: 'TREND',
        noMeasurements: 'Brak pomiarów',
        firstStartsChart: 'Pierwszy pomiar zacznie wykres.',
        targetTitle: 'WAGA DOCELOWA',
        change: 'Zmień',
        reached: 'Osiągnięta — trzymaj formę.',
        left: 'Zostało',
        pace: 'Tempo (4 tyg.)',
        wrongWay: 'Trend idzie teraz w drugą stronę niż cel.',
        paceLater: 'Tempo policzymy po kilku pomiarach w ciągu tygodnia.',
        targetEmpty: 'Bez terminu i presji — zobaczysz, ile zostało i w jakim tempie idziesz.',
        setTarget: 'Ustaw wagę docelową',
        change30: 'Zmiana trendu z 30 dni',
        measurementsTitle: 'POMIARY',
    },
    kgInput: {
        less: 'Mniej o 0,1 kg',
        more: 'Więcej o 0,1 kg',
    },
    qualityPicker: {
        label: 'Jak się spało?',
    },
    sheet: {
        close: 'Zamknij',
    },
    sleepChart: {
        noNight: 'brak nocy',
        unfinished: 'noc niedokończona',
        average: 'średnio {duration}',
    },
    startWizard: {
        weightError: 'Podaj wagę od 20 do 400 kg, np. {example} — albo pomiń.',
        targetError: 'Podaj wagę od 20 do 400 kg — albo pomiń.',
        typesError: 'Wybierz przynajmniej jeden rodzaj — albo pomiń.',
        saveFailed: 'Nie udało się zapisać. Spróbuj ponownie albo pomiń.',
        weight: {
            title: 'Ile dziś ważysz?',
            text: 'Pierwszy pomiar — od niego zacznie się wykres. Najlepiej rano, przed śniadaniem.',
        },
        target: {
            title: 'Masz wagę docelową?',
            text: 'Bez terminu i presji. Pokażemy, ile zostało i w jakim tempie idziesz.',
        },
        types: {
            title: 'Jak się ruszasz?',
            text: 'Wybierz rodzaje treningów — będziesz je wybierać przy każdym treningu. Zmienisz je potem w zakładce Ruch.',
        },
        progress: 'START FORMY · {current} Z {total}',
        skipGuide: 'Pomiń przewodnik',
        weightLabel: 'Waga',
        targetLabel: 'Waga docelowa',
        current: 'Teraz: {weight}',
        ownLabel: 'Własny rodzaj',
        ownPlaceholder: 'Coś innego? np. Tenis',
        skipStep: 'Pomiń ten krok',
        finish: 'Gotowe — pokaż Formę',
        next: 'Dalej',
    },
    targetDialog: {
        title: 'Waga docelowa',
        subtitle: 'Bez terminu — tempo policzymy z Twoich pomiarów.',
        label: 'Chcę ważyć',
        error: 'Podaj wagę od 20 do 400 kg, np. 75.',
        remove: 'Usuń wagę docelową',
    },
    typesSheet: {
        title: 'Rodzaje treningów',
        subtitle: 'Każdy trening ma jeden rodzaj — od niego zależy kolor.',
        exists: '„{name}" już jest na liście.',
        addFailed: 'Nie udało się dodać rodzaju.',
        renameFailed: 'Nie udało się zmienić nazwy.',
        inUse: '„{name}" ma zapisane treningi, więc zostaje. Zmień mu nazwę, jeśli trzeba.',
        newNameAria: 'Nowa nazwa: {name}',
        renameAria: 'Zmień nazwę: {name}',
        deleteAria: 'Usuń: {name}',
        empty: 'Nie masz jeszcze żadnego rodzaju — dodaj pierwszy.',
        newLabel: 'Nowy rodzaj',
        placeholder: 'np. Pływanie',
    },
    weightChart: {
        aria: 'Waga: {n} pomiarów w wybranym okresie',
        target: 'cel {weight}',
        tooltip: '{weight} · trend {trend}',
        empty: 'Brak pomiarów w tym okresie.',
        legendPoint: 'pomiar',
        legendTrend: 'trend (średnia z 7 dni)',
        offScale: 'poza skalą',
    },
    weightDialog: {
        today: 'Dziś',
        yesterday: 'Wczoraj',
        error: 'Podaj wagę od 20 do 400 kg, np. {example}.',
        dayError: 'Wybierz dzień — dziś albo wcześniej.',
        editTitle: 'Edytuj pomiar',
        newTitle: 'Nowy pomiar',
        subtitle: 'Ostatnio {weight} · {date}',
        weightLabel: 'Waga',
        emptyHint: 'Puste pole zapisze {weight} — tyle co ostatnio.',
        dayLabel: 'Dzień',
        replaces: 'Tego dnia jest już pomiar {weight} — zostanie zastąpiony.',
        confirmTitle: 'Usunąć pomiar?',
    },
    firstSteps: {
        night: {
            title: 'Pierwsza noc',
            action: 'Pokaż, jak',
            what: 'Wieczorem tapnij „Kładę się", rano przycisk pobudki — godziny zapiszą się same.',
            why: 'Z kolejnych nocy zobaczysz, ile średnio śpisz i jak równo chodzisz spać. Zapomnianą noc dopiszesz na zakładce Sen.',
        },
        quality: {
            title: 'Oceń noc',
            action: 'Pokaż, jak',
            what: 'Po pobudce jednym tapnięciem: jak się spało.',
            why: 'Ocena obok długości snu pokazuje, ile snu naprawdę Ci służy.',
        },
        weight: {
            title: 'Pierwszy pomiar wagi',
            action: 'Dodaj pomiar',
            what: 'Dzisiejsza waga — najlepiej rano, przed śniadaniem.',
            why: 'Z pomiarów liczymy średnią z 7 dni, więc wahania z dnia na dzień nie zasłaniają kierunku.',
        },
        target: {
            title: 'Waga docelowa',
            action: 'Ustaw cel',
            what: 'Waga, do której zmierzasz — bez terminu.',
            why: 'Zobaczysz, ile zostało, w jakim tempie idziesz i kiedy w tym tempie dojdziesz do celu.',
        },
        types: {
            title: 'Rodzaje treningów',
            action: 'Wybierz rodzaje',
            what: 'Bieganie, siłownia, spacer — to, co robisz najczęściej.',
            why: 'Trening zapisujesz jednym wyborem, a statystyki z 30 dni dzielą się na rodzaje.',
        },
        workout: {
            title: 'Pierwszy trening',
            action: 'Dodaj trening',
            what: 'Rodzaj i czas trwania; dystans i kalorie, jeśli chcesz.',
            why: 'Widzisz tydzień kropka po kropce i to, ile się ruszasz w ostatnich 30 dniach.',
        },
        plan: {
            title: 'Zaplanuj trening',
            action: 'Zaplanuj',
            what: 'Trening na konkretny dzień przed Tobą.',
            why: 'W tym dniu zobaczysz go na stronie głównej Formy i odhaczysz kółkiem, kiedy go zrobisz.',
        },
    },
    help: {
        night: {
            title: 'Ostatnia noc',
            text: 'Wieczorem tapnij „Kładę się", rano przycisk pobudki — godziny zapiszą się same. Po pobudce ocenisz noc jednym tapnięciem.',
            more: 'Noc należy do dnia, w którym się budzisz. Porównanie pokazuje, czy ta noc była dłuższa czy krótsza niż średnia z ostatnich 7 dni.',
        },
        activity: {
            title: 'Ruch w tym tygodniu',
            text: 'Ile treningów i ile czasu. Trening zaplanowany na dziś odhaczasz kółkiem, kiedy go zrobisz.',
        },
        weight: {
            title: 'Waga',
            text: 'Ostatni pomiar, zmiana z 30 dni i trend. „Pomiar" podpowiada ostatnią wagę — zostaje poprawić o kilka dziesiątych.',
        },
        sleepChart: {
            title: 'Sen: długość nocy',
            text: 'Ostatnie 7 albo 30 nocy i średnia. Dotknij słupka, żeby zobaczyć godziny.',
        },
        sleepRegularity: {
            title: 'Regularność',
            text: 'Średnia godzina zaśnięcia i pobudki. Im mniejszy rozrzut, tym równiejszy rytm.',
            more: 'Liczą się tylko pełne noce — z zaśnięciem i pobudką.',
        },
        sleepList: {
            title: 'Wszystkie noce',
            text: 'Tapnij noc, żeby ją poprawić albo dopisać drzemkę. Noc należy do dnia, w którym się budzisz.',
        },
        activityWeek: {
            title: 'Twój tydzień',
            text: 'Pełna kropka — trening zrobiony, obwódka — zaplanowany.',
            more: 'W kropce widać, ile minut trwały treningi tego dnia.',
        },
        activityActions: {
            title: 'Dodaj albo zaplanuj',
            text: '„Trening" zapisuje to, co już za Tobą, „Zaplanuj" — to, co przed Tobą. Tu też edytujesz rodzaje treningów.',
        },
        activityPlanned: {
            title: 'Zaplanowane',
            text: 'Treningi przed Tobą. Kółko oznacza trening jako zrobiony — tapnij nazwę, żeby zmienić dzień albo szczegóły.',
        },
        activityHistory: {
            title: 'Historia',
            text: 'Zrobione treningi tydzień po tygodniu, z łącznym czasem. Tapnij trening, żeby go poprawić.',
        },
        activityStats: {
            title: 'Ostatnie 30 dni',
            text: 'Ile razy, jak długo i jaki dystans — w podziale na rodzaje.',
        },
        weightChart: {
            title: 'Trend wagi',
            text: 'Punkty to pomiary, linia to średnia z 7 dni — wahania z dnia na dzień nie zasłaniają kierunku.',
            more: 'Duża liczba nad wykresem to trend, nie ostatni pomiar.',
        },
        weightTarget: {
            title: 'Waga docelowa',
            text: 'Ustaw cel, a zobaczysz, ile zostało i w jakim tempie idziesz.',
            more: 'Tempo liczymy z trendu ostatnich 4 tygodni.',
        },
        weightList: {
            title: 'Pomiary',
            text: 'Wszystkie pomiary z trendem. Tapnij pomiar, żeby go poprawić albo usunąć.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Formie',
            text: 'Sen, ruch i waga w jednym miejscu. W minutę pokażę Ci, co gdzie jest — możesz to w każdej chwili zamknąć.',
        },
        end: {
            title: 'To wszystko',
            text: 'Sen i treningi możesz dodawać też w planerze dnia — trafią tutaj. Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy każdej sekcji wyjaśnia ją bez przewodnika.',
        },
    },
};
